import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  public firestoreUser$: Observable<any>; // Reactive authentication state

  constructor(private afAuth: AngularFireAuth, private router: Router) {
    this.firestoreUser$ = this.afAuth.authState.pipe(
      switchMap(user => user ? of(user) : of(null)) // Emits user or null
    );
  }

  public getCurrentUser(): Observable<any> {
    return this.afAuth.authState;
  }

  public isAuthenticated(): Observable<boolean> {
    return this.afAuth.authState.pipe(map(user => !!user));
  }

  public login(email: string, password: string): Promise<boolean> {
    return this.afAuth.signInWithEmailAndPassword(email, password)
      .then(() => this.router.navigate(['/partner']))
      .catch(error => { throw error; });
  }

  public logout(): Promise<void> {
    return this.afAuth.signOut();
  }

  public resetPassword(email: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.afAuth.sendPasswordResetEmail(email)
        .then(passwordData => resolve(passwordData), err => reject(err))
    });
  }
}